import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { previewCta, previewEyebrow, previewHighlight, previewImages, previewSubtitle, previewTitle } from '../data/content';
export function Preview() {
  return <section id="vista-previa" className="w-full bg-night-800 py-16 md:py-24" data-id="element-100" data-mp="22q2awloyvjig">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-101" data-mp="1xowhsmre9u8e">
        <header className="mx-auto max-w-narrow text-center" data-id="element-102" data-mp="1sr3cdvxx1496">
          <p className="font-display text-xs font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-103" data-mp="1nzczpjbia4el">
            {previewEyebrow}
          </p>
          <h2 className="mt-5 font-display text-[2rem] font-bold leading-[1.15] tracking-tight text-ink md:text-[2.75rem]" data-id="element-104" data-mp="1jysya3jwgemn">
            {previewTitle}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-105" data-mp="19zai7y741czv">
            {previewSubtitle}
          </p>
        </header>

        <div className="mx-auto mt-14 flex max-w-2xl flex-col gap-10 md:gap-14" data-id="element-106" data-mp="1510ntpt7mgfb">
          {previewImages.map((image, index) => <React.Fragment key={image.src} data-id="element-107" data-mp="333tf36s88l34" data-mpi={index}>
              <figure className="overflow-hidden rounded-2xl ring-1 ring-gold-400/25 shadow-[0_0_70px_-24px_rgba(212,175,55,0.55)]" data-id="element-108" data-mp="37xfvna1ih947">
                <img src={image.src} alt={image.alt} className="block w-full" loading="lazy" decoding="async" data-id="element-109" data-mp="2t9ba7yb2qjhq" />
              </figure>

              {index === 1 && <p className="mx-auto inline-flex max-w-xl items-center justify-center gap-3 rounded-xl bg-night-700 px-6 py-4 text-center font-display text-base font-bold leading-snug tracking-tight text-gold-300 ring-1 ring-gold-400/25 md:text-lg" data-id="element-110" data-mp="3qtxlflwsuyxt">
                  <SparklesIcon className="h-5 w-5 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-111" data-mp="20isyya075bt8" />
                  {previewHighlight}
                </p>}
            </React.Fragment>)}
        </div>

        <div className="mx-auto mt-14 max-w-xl text-center" data-id="element-112" data-mp="70c676m4j5xn">
          <CtaButton size="xl" className="w-full" data-id="element-113" data-mp="70vo4nbrxubo">
            {previewCta}
          </CtaButton>
        </div>
      </div>
    </section>;
}